import React from 'react';

const WatchlistFormModal = React.lazy(() => import('../components/FormModal'));
const watchlistModalRegistry = {
    personalize_watchlistId: WatchlistFormModal
};
export default watchlistModalRegistry;
